import React from "react";
import { Box } from "@chakra-ui/react";
import { useAuth } from "../../auth/AuthContext";
import { Navigate } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";
import AdminGuard from "../components/AdminGuard";

/**
 * Admin Dashboard Page
 * 
 * This is the main admin dashboard page that provides a comprehensive
 * management interface for system administrators.
 * 
 * Features:
 * - Dashboard overview with system statistics
 * - User management
 * - Category management
 * - Employee management
 * - Estate and division management
 * - Block management
 * - Job level management
 * - Foreman group management
 * - Inspection synchronization management
 * - Permission management
 * - System settings
 * 
 * Security:
 * - Only authenticated users can access
 * - Admin permission check via AdminGuard component
 * - Uses /admin/check-permission API endpoint
 */
function AdminDashboardPage() {
  const { user, loading } = useAuth();

  // Show loading while checking authentication
  if (loading) {
    return (
      <Box 
        minH="100vh" 
        display="flex" 
        alignItems="center" 
        justifyContent="center"
        bg="gray.50"
      >
        <Box textAlign="center">
          <Box mb={4}>Loading...</Box>
        </Box>
      </Box>
    );
  }

  // Redirect to login if not authenticated
  if (!user) {
    return <Navigate to="/login" replace />;
  }

  // Use AdminGuard to protect the admin content
  return (
    <AdminGuard>
      <AdminLayout />
    </AdminGuard>
  );
};

export default AdminDashboardPage;
